import SuppliesList from './SuppliesList'

export default {
  list: SuppliesList,
}
